module.exports = __webpack_public_path__ + "img/longde.89aad2c1.png";